




































































import Vue from "vue";
import { mapGetters } from "vuex";

//Model
import { Configuration, Stock } from "@/model/data/security/Configuration";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";
import { StockTypeEnum } from "@/model/data/enums/StockTypeEnum";
import { Denomination } from "@/model/data/Denomination";

export default Vue.extend({
    props: {
        configuration: { type: Object as () => Configuration, required: true },
        rollsProfile: { type: Object as () => RollProfile, required: true },
    },
    data() {
        return {
            StockTypeEnum,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        canReadRollsConfig() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadRolls);
        },

        stocksConfiguration() {
            let stockConfiguration = Array<Stock>();
            if (this.rollsProfile && this.rollsProfile.rollsNumber != null && this.rollsProfile.rollsNumber != undefined) {
                for (let i = 0; i < this.rollsProfile.rollsNumber; i++) {
                    let stock = null;
                    if (this.configuration && this.configuration.rollsConfig && this.configuration.rollsConfig.length) {
                        let s = this.configuration.rollsConfig.filter((s) => s.index == i && s.stockType != StockTypeEnum.Bag);
                        if (s && s.length == 1) stock = s[0];
                    }
                    if (stock == null) {
                        stock = new Stock();
                        stock.index = i;
                        stock.stockType = StockTypeEnum.Roll;
                        stock.cashIn = false;
                        stock.exceed = false;
                        stock.unfit = false;
                        stock.counterfeit = false;
                        stock.suspect = false;
                        stock.denominations = new Array<Denomination>();
                    }
                    stockConfiguration.push(stock);
                }
                if (this.rollsProfile.hasBag) {
                    let stock = null;
                    if (this.configuration && this.configuration.rollsConfig && this.configuration.rollsConfig.length) {
                        let s = this.configuration.rollsConfig.filter((s) => s.stockType == StockTypeEnum.Bag);
                        if (s && s.length == 1) stock = s[0];
                    }
                    if (stock == null) {
                        stock = new Stock();
                        stock.index = 0;
                        stock.stockType = StockTypeEnum.Bag;
                        stock.cashIn = false;
                        stock.exceed = false;
                        stock.unfit = false;
                        stock.counterfeit = false;
                        stock.suspect = false;
                        stock.denominations = new Array<Denomination>();
                    }
                    stockConfiguration.push(stock);
                }
            }
            return stockConfiguration;
        },
        maxRowOptions() {
            let maxRowOptions = [];
            let max = 1;
            let rowIndex = 0;
            if (this.stocksConfiguration && this.stocksConfiguration.length) {
                for (let i = 0; i < this.stocksConfiguration.length; i++) {
                    if (Math.trunc(i / 3) != rowIndex) {
                        rowIndex = Math.trunc(i / 3);
                        maxRowOptions.push(max);
                        maxRowOptions.push(max);
                        maxRowOptions.push(max);
                        max = 1;
                    }
                    let stock = this.stocksConfiguration[i];
                    let optionsSum = stock.cashIn + stock.exceed + stock.unfit + stock.counterfeit + stock.suspect;
                    if (optionsSum > max) max = optionsSum;
                }
                maxRowOptions.push(max);
                maxRowOptions.push(max);
                maxRowOptions.push(max);
            }
            return maxRowOptions;
        },
        hasOptions() {
            if (this.rollsProfile.rollsNumber == 0 && this.rollsProfile.hasBag) return false;
            return true;
        },
    },
});
